define('app/views/slideshow',['require','hammerjs'],function(require){

  var Hammer = require('hammerjs');
  var TweenMax = (TweenMax || TweenLite);

  var DEFAULTS = {
    autoPlay: true,
    autoResize: true,
    touch: true,
    circular: true,
    reverse: false,
    randomize: false,
    spinner: true,
    interval: 7000,
    mode: 'crop', //can be either 'crop' or 'fit'
    animation: 'crossfade', //can be either 'fade' or 'wipe'
    ease: 'Power2.easeInOut', //can be any of the jquery/greensock easing strings
    axis: 'x', //can be either 'x' or 'y' - only applies to wipe animation
    speed: 500,
    slideEl: _.template('<div class="slide <%= template %> anchor-<%= anchor %>" style="background-image:url(\'<%= src %>\')" data-href="<%= link %>"><img src="<%= src %>"/></div>'),
    slide: {
      $el: null,
      loaded: false,
      template: 'slide_default',
      id: 0,
      type: 'image',
      src: '',
      title: '',
      blurb: '',
      link: '',
      anchor: 5
    }
  };

  var Slideshow = Backbone.View.extend({

    index: 0,
    slides: [],
    loading: false,
    slideXHR: null,
    paused: false,
    intervalID: 0,
    cssTransitions: false,
    backgroundSize: false,
    instantNextSlide: false,
    animating: false,
    direction: 1,

    initialize: function(options){
      _.bindAll(this, '_onLoad', '_show', 'next', 'previous', 'resize');

      this.options = $.extend(true, {}, DEFAULTS, (options.setup || {}));
      Backbone.View.prototype.initialize.call(this, options);

      this.$el.addClass(this.options.mode).addClass(this.options.animation).addClass(this.options.axis);

      this.cssTransitions = $('html').hasClass('csstransitions');
      this.backgroundSize = $('html').hasClass('backgroundsize');

      if(this.options.autoResize && !this.backgroundSize){
        $(window).on('resize.slideshow', this.resize);
      }

      /*if(this.options.touch && Hammer){
        var hammer = new Hammer(this.$el.get(0), { dragBlockHorizontal: true, swipeVelocityX: 0.2 });
        hammer.on('swipeleft', this.next);
        hammer.on('swiperight', this.previous);
      }*/

      if(this.options.spinner){
        this.$el.append($('<div class="spinner"/>'));
      }

      var _self = this;
      var arr = [];
      $('img', this.$el).each(function(){
        arr.push($.extend({}, _self.options.slide, $(this).remove().data()));
      });

      this.setSlides(arr);
      this.goto(0, true);
    },

    setOption: function(option, value){
      this.options[option] = value;
    },

    getOption: function(option){
      return this.options[option];
    },

    setSlides: function(slides){
      //cleanup old slide elements
      _.each(this.slides, function(slide){
        if(slide.$el) slide.$el.remove();
      });

      //map new slides and extend defaults
      slides = _.map(slides, function(slide){
        return $.extend({}, this.options.slide, slide);
      }, this);

      if(this.options.reverse) {
        this.slides = slides.reverse();
      } else if(this.options.randomize){
        this.slides = _.shuffle(slides);
      } else {
        this.slides = slides;
      }
    },

    getSlides: function(){
      return this.slides;
    },

    getIndex: function(){
      return this.index;
    },

    getCurrentSlide: function(){
      return this.slides[this.index];
    },

    setPaused: function(paused){
      this.paused = paused;
    },

    getPaused: function(){
      return this.paused;
    },

    setDirection: function(direction){
      this.direction = direction;
    },

    getDirection: function(){
      return this.direction;
    },

    getPaused: function(){
      return this.paused;
    },

    goto: function(index, instant){
      if(index < 0 || index >= this.slides.length){
        //console.log('SLIDESHOW: INVALID SLIDE INDEX');
        return;
      }

      if(this._getLoading() || this._getAnimating()){
        return;
      }

      this.instantNextSlide = (instant || false);

      this._setIndex(index);
    },

    previous: function(){
      if(this._getLoading() || this._getAnimating() || this.slides.length <= 1) return;
      var index = --this.index;
      if(index < 0) index = this.slides.length - 1;
      this.setDirection(0);
      this._setIndex(index);
    },

    next: function(){
      if(this._getLoading() || this._getAnimating() || this.slides.length <= 1) return;
      var index = ++this.index;
      if(index >= this.slides.length) index = 0;
      this.setDirection(1);
      this._setIndex(index);
    },

    resize: function(){
      _.each(this.slides, function(slide){
        this._resize(slide);
      }, this);
    },

    _resize: function(slide){
      var w = this.$el.width();
      var h = this.$el.height();

      if(slide.$el){
        var img = slide.$el.find('> img');
        var imgWidth = img.width();
        if(imgWidth != w){
          img.width(w);
          img.css('height', 'auto');
        }
        var imgHeight = img.height();
        if(imgHeight < h){
          img.height(h);
          img.css('width', 'auto');
        }
        var left = (w - img.width()) / 2
        var top = (h - img.height()) / 2
        img.css({ top: top, left: left });
      }
    },

    _setLoading: function(loading){
      this.loading = loading;
      TweenMax.to($('.spinner', this.$el), 0.2, { alpha: loading ? 1 : 0 });
    },

    _getLoading: function(){
      return this.loading;
    },

    _setAnimating: function(animating){
      this.animating = animating
    },

    _getAnimating: function(){
      return this.animating;
    },

    _setIndex: function(index){
      clearInterval(this.intervalID);
      this.index = index;
      this._stopVideos();
      this._load();
    },

    _autoplay: function(){
      if(!this.options.autoPlay || this.paused || this.slides.length <= 1){
        return false;
      }

      var slide = this.slides[this.index];

      if(slide && slide.type == "video" && slide.BV){
        var player = slide.BV.getPlayer();
        if(player && !player.paused()){
          return false;
        }
      }

      var _self = this;
      this.intervalID = setTimeout(function(){
        _self.next();
      }, this.options.interval);
    },

    _load: function(){
      var slide = this.slides[this.index];

      if(!slide){
        console.log('SLIDESHOW: COULD NOT FIND SLIDE AT INDEX ' + this.index);
        return;
      } else if(slide.$el){
        this._setupSlide();
        return;
      }

      this.trigger(Slideshow.BEFORE_LOAD, this);

      //show the spinner
      this._setLoading(true);

      if(slide.type == 'image') {
        var img = new Image();
        img.onload = this._onLoad;
        img.onerror = this._onLoad;
        img.src = slide.src;
      } else if(slide.type == 'video'){
        this._onLoad();
      } else if(slide.type == 'ajax'){
        var _self = this;
        $.get(slide.endpoint, function(data){
          _self.slides[_self.index] = $.extend({}, slide, data);
          _self._onLoad();
        });
      }
    },

    _onLoad: function(){
      this.trigger(Slideshow.AFTER_LOAD, this);

      this._setLoading(false);

      var slide = this.slides[this.index];

      if(!slide){
        console.log('SLIDESHOW: COULD NOT FIND SLIDE AT INDEX ' + this.index);
        return;
      }

      var _self = this;
      if(window.dust != null && dust.cache[slide.template]){
        dust.render(slide.template, slide, function(err, out){
          slide.$el = $(out);
          _self._setupSlide();
        });
      } else {
        slide.$el = $(this.options.slideEl(slide));
        this._setupSlide();
      }
    },

    _setupSlide: function(){
      var slide = this.slides[this.index];
      if(!slide){
        console.log('SLIDESHOW: COULD NOT FIND SLIDE AT INDEX ' + this.index);
        return;
      }

      this.$el.append(slide.$el.addClass('active'));
      this._resize(slide);

      var _self = this;

      if(slide.type == 'video'){
        if(slide.BV) {
          var player = slide.BV.getPlayer();
          player.currentTime(0);
          player.play();
        } else {
          slide.BV = new $.BigVideo({ container: slide.$el, useFlashForFirefox: true });
          slide.BV.init({ autoplay: true });
          slide.BV.show(slide.videoSrc);
          slide.BV.getPlayer().ready(function(){
            this.on('play', function(){
              _self._show();
            });
            this.on('ended', function(){
              _self._autoplay();
            });
          })
        }
      } else {
        this._show();
      }
    },

    _show: function(){
      this.trigger(Slideshow.BEFORE_SHOW, this);

      var slide = this.slides[this.index];
      if(!slide){
        console.log('SLIDESHOW: COULD NOT FIND SLIDE AT INDEX ' + this.index);
        return;
      }

      var speed = this.instantNextSlide ? 0 : this.options.speed
      this.instantNextSlide = false;
      this._setAnimating(true);

      var _self = this;
      switch(this.options.animation){
        case 'crossfade':
          TweenMax.fromTo(slide.$el, speed / 1000, { alpha: 0 }, { alpha: 1, onComplete: this._showComplete, onCompleteParams: [this._cleanCrossFade], onCompleteScope: this });
          break;
        case 'wipe':
          _.each(this.slides, function(slide, i){
            if(slide.$el){
              if(i == _self.index){
                TweenMax.fromTo(slide.$el, speed / 1000, { left: this.getDirection() ? '100%' : '-100%' }, { left: 0, ease: this.options.ease, onComplete: this._showComplete, onCompleteScope: this });
              } else {
                TweenMax.to(slide.$el, speed / 1000, { left: this.getDirection() ? '-100%' : '100%', ease: this.options.ease, onComplete: this._cleanWipe, onCompleteParams: [slide] });
              }
            }
          }, this);
          break;
      }

      this._autoplay();
    },

    _showComplete: function(fn){
      this._setAnimating(false);
      this.trigger(Slideshow.AFTER_SHOW, this);
      if(fn && _.isFunction(fn)) {
        fn();
      }
    },

    _cleanCrossFade: function(){
      var _self = this;
      _.each(this.slides, function(slide, i) {
        if(i != _self.index){
          if(slide.$el) {
            TweenMax.to(slide.$el, 0, { alpha: 0 });
          }
        }
      });
    },

    _cleanWipe: function(slide){
      if(slide && slide.$el){
        slide.$el.detach();
      }
    },

    _stopVideos: function(){
      _.each(this.slides, function(slide, i) {
        if(slide.type == "video" && slide.BV && slide.BV.getPlayer()){
          slide.BV.getPlayer().pause();
        }
      });
    }

  });

  Slideshow.STARTED = 'slideshowStarted';
  Slideshow.ENDED = 'slideshowEnded';
  Slideshow.BEFORE_LOAD = 'slideshowBeforeLoad';
  Slideshow.AFTER_LOAD = 'slideshowAfterLoad';
  Slideshow.BEFORE_SHOW = 'slideshowBeforeShow';
  Slideshow.AFTER_SHOW = 'slideshowAfterShow';

  return Slideshow;

});
